/*global myDataLayer, isAutocomplete, linkBuilder, autocomplete, dates, onlyDates, abTest470, analyticEventTracker */

var searchbox = {
    pickDate: '',
    sendSearchBoxEvent: false,
    init: function() {
        searchbox.select();
        searchbox.isDropOff();
        searchbox.calendar();
        searchbox.age();
        searchbox.residence();
        searchbox.submit();
        searchbox.ssf();

        var controllers = ['static', 'partners', 'car-types', 'search'];
        if (controllers.indexOf(_d.c) !== -1) {
            searchbox.sendSearchBoxEvent = (_d.c === 'search' ? 'search' : 'landing');
        }

        searchbox.isABTest470 = typeof abTest470 !== 'undefined' && abTest470 === 1;

        let postData = {
            eventName: 'Landing_LocationFormLoaded',
            'attributes[eventAction]': 'search'
        };
        analyticEventTracker.trackEvent(postData);
    },
    fixArabicNumbers: function(dateText) {
        return dateText.replace(/[٠-٩]/g, function(d) {
            return '٠١٢٣٤٥٦٧٨٩'.indexOf(d);
        });
    },
    getFormData: function() {
        var dateFrom = $('#pick-date').val() + ' ' + $('#pick-time').val(),
            dateTill = $('#drop-date').val() + ' ' + $('#drop-time').val(),
            placePick = (isAutocomplete ? $('#pickPlaceID').val() : $('#pick-place').val()),
            placeDrop = (isAutocomplete ? $('#dropPlaceID').val() : $('#drop-place').val()),
            driverAge = $('#driver-age-input').val();

        if (driverAge === '30-65' || driverAge === '65-30') {
            driverAge = '35';
        } else if (driverAge === '80+') {
            driverAge = '80';
        }

        return {
            is_drop_off: ($('#is-drop-off').is(':checked') ? 0 : 1),
            driver_age: driverAge,
            pick_up_country_id: (isAutocomplete ? $('#pickCountryID').val() : $('#pick-country').val()),
            pick_up_city_id: (isAutocomplete ? $('#pickCityID').val() : $('#pick-city').val()),
            pick_up_location_id: placePick,
            drop_off_country_id: (isAutocomplete ? $('#dropCountryID').val() : $('#drop-country').val()),
            drop_off_city_id: (isAutocomplete ? $('#dropCityID').val() : $('#drop-city').val()),
            drop_off_location_id: placeDrop,
            pickup_id: placePick,
            dropoff_id: placeDrop,
            pickup_from: dateFrom,
            pickup_to: dateTill,
            pick_time: $('#pick-time').val(),
            drop_time: $('#drop-time').val(),
            partner_id: $('#partnerId').val(),
            exclude_locations: $('#excludeLocations').val(),
            luxOnly: _d.s.luxOnly,
            residence_country: $('#residence-input').val()
        };
    },
    autoSave: function() {
        $.post(_d.url.search.autoSave, searchbox.getFormData());
    },
    select: function() {
        var countryOptions = {
            inherit_select_classes: true,
            placeholder_text_single: _d.t.please_select_country,
            no_results_text: _d.t.chosen_no_results_text,
            width: (_d.sbm || typeof sfsb !== 'undefined' ? '100%' : '33.33%')
        };
        var cityOptions = {
            inherit_select_classes: true,
            placeholder_text_single: _d.t.please_select_city,
            no_results_text: _d.t.chosen_no_results_text,
            width: (_d.sbm || typeof sfsb !== 'undefined' ? '100%' : '33.33%')
        };
        var placeOptions = {
            inherit_select_classes: true,
            placeholder_text_single: _d.t.please_select_place,
            no_results_text: _d.t.chosen_no_results_text,
            width: (_d.sbm || typeof sfsb !== 'undefined' ? '100%' : '33.33%')
        };
        var timeOptions = {
            inherit_select_classes: true,
            disable_search: true,
            width: '100%'
        };

        var chosenConfig = {
            '#pick-country': countryOptions,
            '#pick-city': cityOptions,
            '#pick-place': placeOptions,
            '#drop-country': countryOptions,
            '#drop-city': cityOptions,
            '#drop-place': placeOptions,
            '#pick-time': timeOptions,
            '#drop-time': timeOptions,
            '#pick-time-clone': timeOptions,
            '#drop-time-clone': timeOptions
        };

        for (var selector in chosenConfig) {
            if (Object.prototype.hasOwnProperty.call(chosenConfig, selector)) {
                var selectHandler = $(selector),
                    selectVal = selectHandler.val();

                selectHandler.chosen(chosenConfig[selector]);

                if (selectVal > 0) {
                    selectHandler.next().addClass('selected');
                } else if (!$('#sb-v3-form select').next().hasClass('choose')) {
                    selectHandler.next().addClass('choose');
                } else if (!selectHandler.hasClass('clock-select')) {
                    selectHandler.prop('disabled', true).trigger('chosen:updated');
                }
            }
        }

        $('.time-select').on('change', function() {
            $('.time-select').next().removeClass('err');
            if (searchbox.isABTest470) {
                $('.time-select').closest('.sb-group').removeClass('error');
            }
            $('.inline-error').slideUp();

            var that = $(this),
                isClone = that.hasClass('clone');

            that.addClass('selected');

            if (isClone) {
                $('#' + that.attr('id').replace('-clone', '')).addClass('selected').val(that.val()).trigger('chosen:updated');
            }

            if (that.attr('id').replace('-clone', '') === 'pick-time' && $('#drop-time').val() === '0') {
                $('#drop-time').val(that.val()).trigger('chosen:updated');

                if (isClone) {
                    $('#drop-time-clone').val(that.val()).trigger('chosen:updated');
                }
            }

            if (that.attr('id').replace('-clone', '') === 'drop-time' && $('#pick-time').val() === '0') {
                $('#pick-time').val(that.val()).trigger('chosen:updated');

                if (isClone) {
                    $('#pick-time-clone').val(that.val()).trigger('chosen:updated');
                }
            }

            // if (that.attr('id') === 'pick-time' && !$('#drop-date-ui').hasClass('selected')) {
            //     $('#drop-date-ui').datepicker('show');
            // }
            //
            // if (that.attr('id') === 'pick-time-clone' && !$('#drop-date-ui-clone').hasClass('selected')) {
            //     $('#drop-date-ui-clone').datepicker('show');
            // }

            if (that.val() !== '0') {
                searchbox.autoSave();
            }
        }).on('chosen:showing_dropdown', function(e) {
            var time = $(e.target);
            if (time.val() === '0') {
                time.next('.chosen-container').find('.chosen-results').scrollTop(40 * 12);
            }

            if (time.hasClass('trigger-gtm-change-search')) {
                myDataLayer.send('change-search', {action: time.data('event-action')});
            }
        });

        $('.sb-select').on('change', function() {
            var that = $(this),
                type = that.data('type'),
                group = that.data('group'),
                handlerReference = ['', ('#' + group + '-country'), ('#' + group + '-city'), ('#' + group + '-place')],
                noFix = true;

            if (that.next().is('select')) {
                noFix = false;
            }

            if (that.attr('id') === 'drop-place' || that.attr('id') === 'pick-place') {
                if ($('#is-drop-off').is(':checked') === false && $(this).attr('id') === 'pick-place') {
                    var dropCountry = $('#drop-country'),
                        dropCity = $('#drop-city'),
                        dropPlace = $('#drop-place'),
                        dropCountryValue = parseInt(dropCountry.val()),
                        dropCityValue = parseInt(dropCity.val()),
                        dropPlaceValue = parseInt(dropPlace.val());


                    if (dropPlaceValue !== 0 && dropCityValue !== 0 && dropCountryValue !== 0) {
                        $('#pick-date-ui').datepicker('show');

                    } else if (dropPlaceValue === 0 && dropCityValue !== 0 && dropCountryValue !== 0) {
                        setTimeout(function() {
                            dropPlace.trigger('chosen:open');
                        }, 10);
                    } else if (dropPlaceValue === 0 && dropCityValue === 0 && dropCountryValue !== 0) {
                        setTimeout(function() {
                            dropCity.trigger('chosen:open');
                        }, 10);
                    } else {
                        dropCountry.prop('disabled', false).trigger('chosen:updated');

                        setTimeout(function() {
                            dropCountry.trigger('chosen:open');
                        }, 10);
                    }

                } else if ($(this).val() !== 0) {
                    if ($('#document').data('page') !== 'search-index') {
                        $('#pick-date-ui').datepicker('show');
                    }
                }
            }


            if (type === 1) {
                if (typeof lpg !== 'undefined') {
                    var country = that.find('option:selected').data('url');
                    $('#countryUrl').val(country);
                    $('#cityUrl').val('');
                    $('#locationUrl').val('');
                    linkBuilder.generateUrl();
                }

                $('#' + group + '-city, #' + group + '-place').next().removeClass('selected');
                searchbox.disableSelect(that);
            }

            if (type === 2) {
                if (typeof lpg !== 'undefined') {
                    var city = that.find('option:selected').data('url');
                    $('#cityUrl').val(city);
                    $('#locationUrl').val('');
                    linkBuilder.generateUrl();
                }

                searchbox.disableSelect(that);
            }

            if (type === 3) {
                if (typeof lpg !== 'undefined') {
                    var location = that.find('option:selected').data('url');
                    $('#locationUrl').val(location);
                    linkBuilder.generateUrl();
                } else {
                    searchbox.autoSave();
                }

                return;
            }

            if (that.val() > 0 && noFix) {
                $(handlerReference[type]).next().removeClass('choose chosen-container-active').attr('class');
                $(handlerReference[type + 1]).next().addClass('loading choose');
            } else {
                $(handlerReference[type + 1]).next().removeClass('loading choose');
            }

            $.post(_d.url.landing_generator, {'type': type, 'id': that.val()}, function(response) {

                if (!response.error) {
                    var oNext = (type + 1),
                        object = $(handlerReference[oNext]);

                    if (typeof sfsb !== 'undefined') {
                        that.parent().nextAll().find('select').eq(0).prop('disabled', false).trigger('chosen:updated');
                    } else {
                        that.nextAll('select').eq(0).prop('disabled', false).trigger('chosen:updated');
                    }

                    for (var i = oNext; i < handlerReference.length; i++) {
                        $($(handlerReference[i])).empty().append('<option value="0"></option>').trigger('chosen:updated');
                        $($(handlerReference[i])).next().removeClass('selected loading');
                    }

                    $.each(response.data, function(i, item) {
                        object.append('<option value="' + item.id + '" data-country="' + item.countryCode + '" data-city="' + item.p1name + '" data-url="' + (item.iata ? item.iata.toLowerCase() : item.url) + '" data-iata="' + item.iata + '" data-type="' + item.type_id + '">' + item.name + '</option>');
                    });

                    object.trigger('chosen:updated');

                    if (typeof lpg === 'undefined') {
                        if (!noFix) {

                            if (response.data.length === 1) {
                                object[0].selectedIndex = 1;
                                object.change();
                            } else {
                                object.first().focus().click();
                            }

                        } else if (response.data.length === 1) {

                            object[0].selectedIndex = 1;
                            object.trigger('chosen:updated');
                            object.trigger('change');

                            object.next().addClass('selected').removeClass('err');
                            $('.inline-error').slideUp();
                        } else {

                            object.trigger('chosen:open');

                        }
                    }
                }
            }, 'json');
        }).on('chosen:showing_dropdown', function(e) {
            var dropdown = $(e.target);
            if (dropdown.hasClass('change-search-data')) {
                myDataLayer.send('change-search', {action: dropdown.data('event-action')});
            }
        }).on('chosen:hiding_dropdown', function() {
            var that = $(this);

            that.next().removeClass('err selected choose loading');

            if (that.val() > 0) {
                that.next().addClass('selected');
            } else {
                that.next().addClass('choose');
            }
        });
    },
    disableSelect: function(handler) {
        handler.nextAll('select').prop('disabled', true).empty().trigger('chosen:updated');
    },
    isDropOff: function() {
        $('#is-drop-off, #is-drop-off-sticky').on('click', function() {
            var dropOffHandler = $('.sb-group.drop-off'),
                stickyIsDropOff = $('#is-drop-off-sticky'),
                stickyLocation = $('.sticky-location'),
                homeCaption = $('.home-caption-bottom');

            if ($(this).prop('checked')) {
                $('input.is-drop-off').prop('checked', true).trigger('change');

                if (searchbox.isABTest470) {
                    $('.sb-group.pick-drop').removeClass('flex');
                }

                dropOffHandler.hide();
                homeCaption.show();

                if (stickyIsDropOff.length > 0) {
                    if (stickyIsDropOff.hasClass('sticky')) {
                        stickyLocation.removeClass('open-drop-off');
                    }
                }
            } else {
                $('input.is-drop-off').prop('checked', false).trigger('change');

                if (searchbox.isABTest470) {
                    $('.sb-group.pick-drop').addClass('flex');
                }

                var dropCountry = $('#drop-country'),
                    dropCity = $('#drop-city'),
                    dropPlace = $('#drop-place'),
                    dropCountryValue = parseInt(dropCountry.val()),
                    dropCityValue = parseInt(dropCity.val());

                dropCountry.prop('disabled', false).trigger('chosen:updated');

                if ($('#pick-place').val() > 0 && dropCountryValue === 0) {
                    dropCountry.next().addClass('choose');
                }
                if (dropCountryValue > 0) {
                    dropCity.prop('disabled', false).trigger('chosen:updated');
                }
                if (dropCityValue > 0) {
                    dropPlace.prop('disabled', false).trigger('chosen:updated');
                }

                dropOffHandler.show();
                homeCaption.hide();

                if (stickyIsDropOff.length > 0) {
                    if (stickyIsDropOff.hasClass('sticky')) {
                        stickyLocation.addClass('open-drop-off');
                    }
                }
            }
        });
    },
    parseDate: function(date) {
        date = new Date(date);
        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    },
    calendar: function() {
        let dateFormat = _d.specificDateFormats[_d.s.language] ? _d.specificDateFormats[_d.s.language] : null;

        if (dateFormat === null) {
            if (typeof abTest470 !== 'undefined' && abTest470 === 1) {
                dateFormat = 'M d, D';
            } else {
                dateFormat = (_d.s.language === 'en'
                    ? (_d.sbm ? 'M d, yy' : 'D, M d, yy')
                    : (_d.sbm ? 'd M, yy' : 'D, d M, yy'));
            }
        }

        $('.date-field').each(function() {
            var that = $(this),
                useDateFormat = (typeof that.data('format') !== 'undefined' ? that.data('format') : dateFormat),
                isClone = that.hasClass('clone'),
                elementID = '#' + that.attr('id').replace((isClone ? '-ui-clone' : '-ui'), ''),
                parsedDate = $.datepicker.parseDate('yy-mm-dd', $(elementID).val()),
                newDate = $.datepicker.formatDate(useDateFormat, parsedDate, {
                    dayNames: _d.t.datepicker_weekdays_full,
                    dayNamesShort: _d.t.datepicker_weekdays_short,
                    dayNamesMin: _d.t.datepicker_weekdays_short,
                    monthNames: _d.t.datepicker_months_full,
                    monthNamesShort: _d.t.datepicker_months_short
                });

            that.datepicker({
                firstDay: 1,
                altField: elementID,
                altFormat: 'yy-mm-dd',
                numberOfMonths: 2,
                showButtonPanel: false,
                dateFormat: useDateFormat,
                prevText: '',
                nextText: '',
                minDate: new Date(new Date().getTime()),
                dayNames: _d.t.datepicker_weekdays_full,
                dayNamesShort: _d.t.datepicker_weekdays_short,
                dayNamesMin: _d.t.datepicker_weekdays_short,
                monthNames: _d.t.datepicker_months_full,
                monthNamesShort: _d.t.datepicker_months_short,
                beforeShow: function(input, inst) {
                    // Format the numbers to Western Arabic
                    $(input).val(searchbox.fixArabicNumbers($(input).val()));

                    var pickDateHandler = $('#pick-date-ui' + (isClone ? '-clone' : ''));

                    searchbox.pickDate = $('#pick-date').val();

                    if (searchbox.isABTest470) {
                        that.prev().addClass('active');
                    }

                    that.addClass('active');

                    setTimeout(function() {

                        if (window._d.isRTL) {
                            inst.dpDiv.css({
                                top: pickDateHandler.offset().top + $('#ui-datepicker-div').height,
                                right: (($(window).width() - $('#search-box-form').width() ) /2),
                                left: 'auto'
                            });

                            // Search page date selector or partners in place selector
                            if (('.supplier-top-block .search-box-wrapper .sb-group.dates.left').length || $('.search-modify .sb-group.dates.left').length) {
                                const inputFieldRight = $(window).width() - (pickDateHandler.offset().left + pickDateHandler.outerWidth());

                                inst.dpDiv.css({
                                    right: inputFieldRight,
                                    left: 'auto',
                                    'z-index': 12
                                });
                            }
                        } else {
                            inst.dpDiv.css({
                                top: pickDateHandler.offset().top + $('#ui-datepicker-div').height,
                                left: pickDateHandler.offset().left
                            });
                        }

                        if (inst.dpDiv.position().top > $(input).position().top) {
                            inst.dpDiv.removeClass('ui-above').addClass('ui-below');
                        } else {
                            inst.dpDiv.removeClass('ui-below').addClass('ui-above');
                        }

                        if ($(input).hasClass('inverted')) {
                            inst.dpDiv.removeClass('ui-below').addClass('ui-above');
                        }
                    }, 0);
                },
                beforeShowDay: function(date) {
                    var dropDate,
                        pickDateHandler = $('#pick-date-ui' + (isClone ? '-clone' : '')),
                        dropDateHandler = $('#drop-date-ui' + (isClone ? '-clone' : '')),
                        parsedDate = searchbox.parseDate(date);

                    if (that.attr('id') === 'pick-date-ui' + (isClone ? '-clone' : '')) {
                        if (pickDateHandler.hasClass('selected')) {
                            dropDate = dropDateHandler.datepicker('getDate');

                            if (dropDate !== null) {
                                dropDate = searchbox.parseDate(dropDate);

                                if (dropDate && parsedDate === dropDate) {
                                    return [true, 'ui-state-pickup-date', ''];
                                } else if (searchbox.pickDate && dropDate && dates.compare(parsedDate, searchbox.pickDate) > 0 && dates.compare(parsedDate, dropDate) < 0) {
                                    return [true, 'ui-state-pickup-dates', ''];
                                }
                            }
                        }

                        return [true, '', ''];
                    } else if (dropDateHandler.hasClass('selected')) {
                        if (searchbox.pickDate && parsedDate === searchbox.pickDate) {
                            return [true, 'ui-state-pickup-date', ''];
                        } else {
                            dropDate = $('#drop-date').val();
                            if (searchbox.pickDate && dropDate && dates.compare(parsedDate, searchbox.pickDate) > 0 && dates.compare(parsedDate, dropDate) < 0) {
                                return [true, 'ui-state-pickup-dates', ''];
                            }
                        }
                    }

                    return [true, '', ''];
                },
                onSelect: function(dateStr) {
                    dateStr = searchbox.fixArabicNumbers(dateStr);
                    var pickDateHandler = $('#pick-date-ui' + (isClone ? '-clone' : '')),
                        dropDateHandler = $('#drop-date-ui' + (isClone ? '-clone' : '')),
                        dropDate = '';

                    $('.time-select.err').removeClass('err');
                    $('.inline-error').slideUp();

                    if (that.attr('id') === 'pick-date-ui' + (isClone ? '-clone' : '')) {

                        // if (!$('#pick-time' + (isClone ? '-clone' : '')).hasClass('selected')) {
                        //     setTimeout(function(){ $('#pick-time' + (isClone ? '-clone' : '')).trigger("chosen:open"); }, 400);
                        // }

                        dropDate = that.datepicker('getDate');

                        if (dropDateHandler.datepicker('getDate') < pickDateHandler.datepicker('getDate')) {
                            dropDate.setDate(dropDate.getDate());

                            dropDateHandler.datepicker('option', 'defaultDate', dropDate);
                            dropDateHandler.datepicker('option', 'minDate', dateStr);

                            if ($('#pick-time' + (isClone ? '-clone' : '')).hasClass('selected')) {
                                setTimeout(function() {
                                    dropDateHandler.datepicker('show');
                                }, 400);
                            }
                        } else {
                            dropDateHandler.datepicker('option', 'minDate', dateStr);
                        }

                        if (isClone) {
                            $('#pick-date-ui').datepicker('setDate', pickDateHandler.datepicker('getDate'));
                        }
                        pickDateHandler.addClass('selected');
                    } else {

                        dropDateHandler.addClass('selected');

                        if (dropDateHandler.datepicker('getDate') < pickDateHandler.datepicker('getDate')) {
                            pickDateHandler.datepicker('setDate', dateStr);
                        }

                        if (isClone) {
                            $('#drop-date-ui').datepicker('setDate', dropDateHandler.datepicker('getDate'));
                        }

                        searchbox.autoSave();
                    }
                },
                onClose: function() {
                    if (searchbox.isABTest470) {
                        that.prev().removeClass('active');
                    }
                    that.removeClass('active');
                }
            }).val(newDate);
            $('.ui-datepicker').addClass('notranslate');

        });
    },
    openPickTime: function() {
        if (!$('#pick-time').hasClass('selected')) {
            setTimeout(function() {
                $('#pick-time').trigger('chosen:open');
            }, 400);
        }
    },
    age: function() {

        $('.sb-driver-age-text').on('click', function() {
            var that = $(this),
                parent = that.parent(),
                age = $('#driver-age-input').val().toString(),
                child = $('#age-template').html();

            $('.age-dropdown').addClass('closed');

            if (!parent.hasClass('appended')) {
                parent.append('<div class="age-dropdown">' + child + '</div>').addClass('appended');
            } else {
                parent.find('.age-dropdown').toggleClass('closed');
            }

            if (searchbox.sendSearchBoxEvent) {
                var myDataLayerMode;
                if (searchbox.sendSearchBoxEvent === 'landing') {
                    myDataLayerMode = 'search-box';
                } else {
                    myDataLayerMode = 'change-search';
                }

                myDataLayer.send(myDataLayerMode, {action: 'Age'});
            }

            var ageOffsetTop = that.offset().top - parent.find('.age-dropdown').outerHeight();

            if ($(window).scrollTop() > ageOffsetTop) {
                parent.find('.age-dropdown').addClass('bottom');
            } else {
                parent.find('.age-dropdown').removeClass('bottom');
            }

            parent.find('.age-select-list li').removeClass('selected');
            if (age === '35') {
                age = '30-65';
            }
            parent.find('.age-select-list li[data-value="' + age + '"]').addClass('selected');

            var parentDiv = parent.find('.age-select-list'),
                childDiv = parentDiv.find('.selected');

            setTimeout(function() {
                parentDiv.scrollTop(parentDiv.scrollTop() + childDiv.position().top - (parentDiv.height() / 2) + (childDiv.outerHeight() / 2));
            }, 10);

        });

        $('.residence-and-age').on('click', '.age-select-list li', function(e) {
            e.stopPropagation();

            var that = $(this),
                val = that.data('value');

            $('.age-select-list li').removeClass('selected');
            that.addClass('selected');
            $('.age-dropdown').addClass('closed');

            var yearRange = val;
            if (yearRange==='30-65' && window._d.isRTL) {
                yearRange='65-30';
            }

            $('.sb-driver-age-text').text(yearRange);

            $('#driver-age-input').val(val);
            searchbox.autoSave();
        });

        $(document).keyup(function(e) {
            if (e.keyCode === 27) {
                $('.age-dropdown, .residence-dropdown').addClass('closed');
            }
        });
    },
    residence: function() {
        var residenceOptions = {
            inherit_select_classes: true,
            placeholder_text_single: _d.t.please_select_country,
            no_results_text: _d.t.chosen_no_results_text,
            max_selected_options: 1,
            search_contains: true,
            width: '270px'
        };

        $('.sb-residence-text').on('click', function(e) {
            e.stopPropagation();

            var that = $(this),
                parent = that.parent(),
                id = parent.attr('id'),
                child = $('#residence-template').html();

            $('.age-dropdown').addClass('closed');

            if (!parent.hasClass('appended')) {
                parent.append('<div class="residence-dropdown' + (id === 'sb-country' ? ' default' : '') + '">' + child.replace('residence-country', 'residence-' + id) + '</div>').addClass('appended');

                $('#residence-' + id).val($('#residence-input').val())
                    .chosen(residenceOptions)
                    .on('change', function() {
                        var val = $('#residence-' + id + ' option:selected').text();

                        if (val.length > 0) {
                            $('.sb-residence-text').text(val);
                            $('#residence-input').val($(this).val());
                            $('#residence-' + id).chosen('destroy');
                            $('.residence-dropdown').addClass('closed');
                            searchbox.autoSave();
                        }
                    })
                    .on('chosen:hiding_dropdown', function() {
                        $('.residence-dropdown').addClass('closed');
                        $('#residence-' + id).chosen('destroy');
                    });
            } else {
                $('#residence-' + id).val($('#residence-input').val()).chosen(residenceOptions);
                parent.find('.residence-dropdown').removeClass('closed');
            }

            if (searchbox.sendSearchBoxEvent) {
                var myDataLayerMode;
                if (searchbox.sendSearchBoxEvent === 'landing') {
                    myDataLayerMode = 'search-box';
                } else {
                    myDataLayerMode = 'change-search';
                }

                myDataLayer.send(myDataLayerMode, {action: 'Residency'});
            }

            var residenceOffsetTop = that.offset().top - 270;

            if ($(window).scrollTop() > residenceOffsetTop) {
                parent.find('.residence-dropdown').addClass('bottom');
            } else {
                parent.find('.residence-dropdown').removeClass('bottom');
            }

            $('#residence-' + id).trigger('chosen:open');
        });
    },
    submit: function() {

        $('#sb-form-submit').on('click', function(e) {
            e.preventDefault();

            var that = $(this),
                error = false,
                errorMsg = [],
                post = searchbox.getFormData();

            that.addClass('loading');

            if (post.pick_up_country_id === '0') {
                $('#pick_country_chosen').addClass('err');
                errorMsg.push(_d.t.selectPickUpCountry);
                error = true;
            } else if (post.pick_up_city_id === '0') {
                $('#pick_city_chosen').addClass('err');
                errorMsg.push(_d.t.selectPickUpCity);
                error = true;
            } else if (post.pick_up_location_id === '0') {
                $('#pick_place_chosen').addClass('err');
                errorMsg.push(_d.t.selectPickUp);
                error = true;
            }

            if (post.is_drop_off === 1) {
                if (post.drop_off_country_id === '0') {
                    $('#drop_country_chosen').addClass('err');
                    errorMsg.push(_d.t.selectDropOffCountry);
                    error = true;
                } else if (post.drop_off_city_id === '0') {
                    $('#drop_city_chosen').addClass('err');
                    errorMsg.push(_d.t.selectDropOffCity);
                    error = true;
                } else if (post.drop_off_location_id === '0') {
                    $('#drop_place_chosen').addClass('err');
                    errorMsg.push(_d.t.selectDropOff);
                    error = true;
                }
            }

            if (post.pick_time === '0') {
                $('#pick_time_chosen').addClass('err');
                errorMsg.push(_d.t.selectPickTime);
                error = true;
            }

            if (post.drop_time === '0') {
                $('#drop_time_chosen').addClass('err');
                errorMsg.push(_d.t.selectDropTime);
                error = true;
            }

            if (post.pickup_from === post.pickup_to && post.pick_time !== '0' && post.pick_time !== '0') {
                $('#pick_time_chosen, #drop_time_chosen').addClass('err');
                errorMsg.push(_d.t.wrongTimes);
                error = true;
            }

            if (error) {
                var errorHandler = $('.inline-error');
                errorHandler.html('').append('<ul id="error-list"></ul>');
                that.removeClass('loading');

                for (var i = 0; i < errorMsg.length; i++) {
                    $('#error-list').append('<li>' + errorMsg[i] + '</li>');
                }

                searchbox.secondFormError();
                errorHandler.slideDown();
                return false;
            }

            $.post(_d.url.search.createSearch, post, function(response) {
                if (response.success) {
                    document.location.href = response.data.url;
                } else {
                    var errorHandler = $('.inline-error');

                    $('#sb-form-submit').removeClass('loading');
                    errorHandler.html('').append('<ul id="error-list"></ul>');

                    $.each(response.errors.message, function(index) {
                        if (typeof response.errors.message[index] !== 'undefined') {
                            $('#error-list').append('<li>' + response.errors.message[index] + '</li>');
                        }
                    });

                    if (typeof onlyDates !== 'undefined' && onlyDates) {
                        $('html, body').animate({
                            scrollTop: 0
                        }, 400, function() {
                            $('#ssf-submit').removeClass('loading');
                        });
                    }

                    $.each(response.errors.fields, function(index, value) {
                        $('#' + value).addClass('err');
                    });

                    errorHandler.slideDown();
                }
            }, 'json');
        });
    },
    ssf: function() {
        $('.ssf-change').on('click', function(e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 600);
        });

        $('#ssf-submit').on('click', function(e) {
            e.preventDefault();
            var dropForm = $('#sb-form-submit');

            if (dropForm.length > 0) {
                dropForm.click();
            } else {
                $('#location-submit').click();

                if ($('.error-list').length > 0) {
                    searchbox.secondFormError();
                }
            }
        });

        $('#submit-sf').on('click', function(e) {
            e.preventDefault();
            var that = $(this);
            that.addClass('loading');
            autocomplete.submitSearchForm(that);
        });
    },
    secondFormError: function() {
        $('html, body').animate({
            scrollTop: 0
        }, 400, function() {
            $('#ssf-submit').removeClass('loading');
        });
    }
};
